import PriceCampaignUpdateSecondLine from './PriceCampaignUpdateSecondLine'

export default PriceCampaignUpdateSecondLine
